exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CheckBoxList__checkboxList___b9BM5 h4{font-size:12px;line-height:12px;font-weight:700;color:#2b515d}.CheckBoxList__checkboxList___b9BM5 ul{list-style:none;padding:12px 0 4px;text-align:left}.CheckBoxList__checkboxList___b9BM5 li{list-style:none;text-align:left;font-weight:400;color:#000;line-height:24px}.CheckBoxList__checkBoxItem___batlr{width:110px}.CheckBoxList__checkBoxItemFull___3P92h img{display:inline-block;margin-top:5px;width:auto}.CheckBoxList__labelDetail___3eDqF{color:#ccc}.CheckBoxList__ksw_filters_vt___BQT0g{border-bottom:1px solid #ccc}.CheckBoxList__tooltipBody___3ZEhD{left:auto;width:200%;transform:translateX(50%) translateY(50%);padding-right:18px;top:20%;position:absolute}@media(max-width:960px){.CheckBoxList__tooltipBody___3ZEhD{transform:translateX(0) translateY(0);left:5%;position:fixed;z-index:100;width:100%;max-width:80%}}", ""]);

// exports
exports.locals = {
	"checkboxList": "CheckBoxList__checkboxList___b9BM5",
	"checkBoxItem": "CheckBoxList__checkBoxItem___batlr",
	"checkBoxItemFull": "CheckBoxList__checkBoxItemFull___3P92h",
	"labelDetail": "CheckBoxList__labelDetail___3eDqF",
	"ksw_filters_vt": "CheckBoxList__ksw_filters_vt___BQT0g",
	"tooltipBody": "CheckBoxList__tooltipBody___3ZEhD"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/assets/CheckBoxList/CheckBoxList.pcss
// module id = 864
// module chunks = 0